export const ADMIN_ROLE = 'admin'
export const SYSTEM_ROLE = 'system'
export const MANUFACTURER_ROLE = 'manufacturer'
export const DISTRIBUTOR_ROLE = 'distributor'
export const CUSTOMER_ROLE = 'customer'
